// extracted by mini-css-extract-plugin
export default {"dummy":"DummyBanner-module__dummy___QKNTc","mobile":"DummyBanner-module__mobile___vHwrz","fixed-banner":"DummyBanner-module__fixed-banner___Q5m47"};